/**
  Strip HTML tags and links from text
 */
export default function htmlToPlainText(str: string): string {
  return str
    .replace(/(https?:\/\/[^\s]+)/gi, '')
    .replace(/<p>/gi, ' ')
    .replace(/<([^>]+)>/gi, '')
    .replace(/&nbsp;/gi, ' ');
}
